// core/action/salesDashboardActions.js
import { salesDashboardAPI } from './api';

export const salesDashboardActions = {
    getDashboardData: async (params = {}) => {
        try {
            const response = await salesDashboardAPI.get(params);
            
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            
            return {
                success: false,
                message: response.message || 'Failed to load dashboard data'
            };
        } catch (error) {
            console.error('Error fetching sales dashboard:', error);
            return {
                success: false,
                message: error.message || 'Failed to load dashboard data'
            };
        }
    },

    // Get sales person info
    getSalesPersonInfo: async (id) => {
        try {
            const response = await salesDashboardAPI.getPersonInfo(id);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load sales person info'
            };
        } catch (error) {
            console.error('Error fetching sales person info:', error);
            return {
                success: false,
                message: error.message || 'Failed to load sales person info'
            };
        }
    },

    // Get tasks
    getTasks: async (params = {}) => {
        try {
            const response = await salesDashboardAPI.getTasks(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load tasks'
            };
        } catch (error) {
            console.error('Error fetching tasks:', error);
            return {
                success: false,
                message: error.message || 'Failed to load tasks'
            };
        }
    },

    // Add task
    addTask: async (taskData) => {
        try {
            const response = await salesDashboardAPI.addTask(taskData);
            if (response.data && response.success) {
                return {
                    success: true,
                    message: response.message || 'Task added successfully'
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to add task'
            };
        } catch (error) {
            console.error('Error adding task:', error);
            return {
                success: false,
                message: error.message || 'Failed to add task'
            };
        }
    },

    // Update task status
    updateTaskStatus: async (id, status) => {
        try {
            const response = await salesDashboardAPI.updateTaskStatus(id, status);
            if (response.data && response.success) {
                return {
                    success: true,
                    message: response.message || 'Task updated successfully'
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to update task'
            };
        } catch (error) {
            console.error('Error updating task:', error);
            return {
                success: false,
                message: error.message || 'Failed to update task'
            };
        }
    },

    // Format currency
    formatCurrency: (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    },

    // Format compact number
    formatCompactNumber: (num) => {
        if (num >= 10000000) return (num / 10000000).toFixed(1) + 'Cr';
        if (num >= 100000) return (num / 100000).toFixed(1) + 'L';
        if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
        return num.toString();
    },

    // Get priority badge class
    getPriorityBadge: (priority) => {
        const classes = {
            'high': 'bg-danger',
            'medium': 'bg-warning',
            'low': 'bg-info'
        };
        return classes[priority] || 'bg-secondary';
    },

    // Get status badge class
    getStatusBadge: (status) => {
        const classes = {
            'completed': 'bg-success',
            'pending': 'bg-warning',
            'cancelled': 'bg-danger'
        };
        return classes[status?.toLowerCase()] || 'bg-secondary';
    }
};

export default salesDashboardActions;